import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import { getProps, getRoot, getSecondProps } from 'utils/selectors';

import { COUNTRY_TRANSLATION_KEY } from '../../constants';
import type { TranslationsByLanguage } from '../../types';
import { getState as getParent } from '../index';

const getState = createSelector(getParent, ({ data }) => data);

export const getLocale = createSelector(getState, ({ locale }) => locale);

const getTranslations = createSelector(getState, ({ messages }) => messages);

const getTranslationsByLocale = createSelector(
  getTranslations,
  getProps<string>,
  (messages, language) => messages[language] ?? {}
);

export const getTranslation = createSelector(
  getTranslationsByLocale,
  getSecondProps<string>,
  (messages, key): MayBe<string> => messages[key]
);

export const getTranslationsForCurrentLocale = createSelector(getRoot, getLocale, getTranslationsByLocale);

export const getTranslationsByKey = createSelector(getTranslations, getProps<string>, (dictionary, key) =>
  Object.keys(dictionary).reduce<TranslationsByLanguage>(
    (acc, language) => ({ ...acc, [language]: dictionary[language][key] }),
    {}
  ));

export const getCountryTranslations = createSelector(getTranslationsForCurrentLocale, translations =>
  Object.entries(translations).reduce<Record<string, string>>((acc, [key, value]) => {
    const match = key.match(COUNTRY_TRANSLATION_KEY);
    if (match) {
      return {
        ...acc,
        [match[1].toUpperCase()]: value,
      };
    }
    return acc;
  }, {}));
